import {Play, Video} from 'lucide-react'
import {useLanguage} from '@/contexts/LanguageContext'

function Hero() {
  const {t} = useLanguage()

  return (
    <section className="relative z-10 px-6 py-16 md:py-24">
      <div className="max-w-5xl mx-auto text-center">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6 text-white leading-[1.1] tracking-tight">
          {t.hero.titleBefore}
          <span className="bg-gradient-to-r from-indigo-400 via-sky-400 to-cyan-300 bg-clip-text text-transparent">
            {t.hero.titleHighlight}
          </span>
          {t.hero.titleAfter}
        </h1>
        <p className="text-lg md:text-xl text-gray-400 mb-10 max-w-3xl mx-auto leading-relaxed">
          {t.hero.subtitle}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-14">
          <a
            href="https://t.me/slavique"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-500 to-sky-400 text-white font-semibold shadow-lg shadow-indigo-500/30 hover:shadow-indigo-500/50 transition-all duration-300 hover:scale-[1.03] rounded-md text-base h-12 px-6"
          >
            <Play className="w-5 h-5" />
            {t.hero.ctaPrimary}
          </a>
          <a
            href="https://drive.google.com/file/d/19mVTxlzl1iUeAHWl9Ftrn6i5g45D119t/view?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 font-medium border border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white focus:bg-blue-500 focus:text-white transition-all duration-300 rounded-md text-base h-12 px-6"
          >
            <Video className="w-5 h-5" />
            {t.hero.ctaSecondary}
          </a>
        </div>
        <div className="relative mx-auto" style={{width: '896px', maxWidth: '100%'}}>
          <div className="relative rounded-2xl overflow-hidden shadow-[0_25px_60px_-12px_rgba(0,0,0,0.5),0_0_60px_-10px_rgba(56,189,248,0.35)]" style={{width: '896px', height: '896px', maxWidth: '100%'}}>
            <video
              src="https://nygma.io/assets/nygma-platform-demo-D08_t5f4.mp4"
              poster="https://static.lumi.new/49/49eafcd8b3bf73a85099580b85dbb13a.png"
              autoPlay
              muted
              loop
              playsInline
              aria-label={t.hero.imageAlt}
              className="w-full h-full object-contain block"
            >
              Your browser does not support the video tag.
            </video>
            <div className="absolute inset-0 bg-gradient-to-br from-indigo-500 to-sky-400 opacity-10 pointer-events-none" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
